<template>
    <div class="container">
        <h1>热线咨询服务协议书</h1>
        <div style="text-align: left;">
            <p>重要提示：</p>
            <p>阿威达通信技术（深圳）有限公司西安分公司(简称“Aviat”)特别提示您，在进行后续操作前，请事先认真阅读本服务协议条款内容。用户在使用过程中，
            点击“我已仔细阅读并接受《热线咨询服务协议书》”即表示您完全接受并同意遵守本服务协议条款的全部内容。如您不同意本服务条款，请立即停止使用。</p>
            <br/>
            <p>甲方：【阿威达通信技术（深圳）有限公司西安分公司】</p>
            <p>乙方：【公司/个人名称】</p>
            <p>鉴于乙方希望通过电话热线/微信公众号咨询来获取关于 AVIAT 技术服务，双方经友好协商达成如下协议：</p>
            <p>第一条 服务内容与范围</p>
            <p>1. 甲方承诺为乙方提供电话热线技术支持服务，内容包括下方面：</p>
            <p>  a) 【电话热线技术支持服务】</p>
            <p>b) 【通过电脑等方式远程接入微波设备进行故障判断和技术服务】</p>
            <p>c) 【通过微信公众号进行技术支持服务】</p>
            <p>2. 乙方可通过甲方公众号（阿威达微波）提出服务申请，写明需要甲方进行支持的内容，待甲方确认后，乙方通过公众号支付费用，甲方提供相关技术支持。</p>
            <p>第二条 服务时间与费用</p>
            <p>1. 乙方如需要甲方提供服务，应首先在甲方公众号（阿威达微波）中明确声明所需要提供的技术支持内容或需要解决的故障现象并支付费用，费用支付后本协议开始生效。</p>
            <p>2. 甲方在收到乙方费用支付证明后即开始提供技术支持服务，直到对乙方在公众号里声明所需的技术服务和设备故障提出解决方案后，本协议终止。</p>
            <p>3. 甲方热线支持服务费用为按次收费和包年服务两种，按次收费服务乙方只需在甲方公众号（阿威达微波）上进行支付即可，包年服务乙方需要联系甲方相关区域经理签订另外的包年技术服务协议。</p>
            <p>第三条 服务费用与甲乙方责任</p>
            <p>1. 技术支持服务费用为￥500.00 元/次，乙方在甲方提供的微信公众号（阿威达微波）上进行支付。</p>
            <p>2. 这里的“一次”定义为甲方对乙方所声明的故障提出解决方案并通过远程手段（电话，远程登陆，微信公众号）支持乙方所声明的故障。如果在此期间乙方出现了其它没有声明的故障需要处理，应计算为另一次技术支持，乙方应追加费用。</p>
            <p>3. 甲方只负责对乙方进行远程技术支持，如果乙方需要甲方提供现场技术支持，应另行支付费用。</p>
            <p>4. 乙方应按照甲方的指导在现场对设备进行实际操作。如果乙方无故拒绝按照甲方指导进行操作，甲方将认为本次技术支持服务完成，协议终止，费用不予退还。</p>
            <p>5．乙方现场操作人员必须具有基本的微波设备安装调测知识，并对现场设备配置，连接及网络运行情况完全了解。由于乙方操作失误或乙方提供的信息有误，从而导致设备故障或链路中断等问题，责任由乙方承担。</p>
            <p>6. 技术支持期间如果乙方没有提前声明，甲方默认乙方授权甲方对需要支持的设备进行远程重启、配置和维护等操作，如果不能中断电路，乙方也要提前告知，否则由此引起的链路中断与甲方无关。</p>
            <p>7. 由于甲方提供的是远程技术支持，所以甲方只承诺提出解决方案，并不承诺一定能够解决乙方出现的需求。</p>
            <p>8. 乙方在公众号上提出技术支持的需求并支付费用后默认乙方接受本协议条款，除非甲方有违反协议规定的行为发生，否则甲方不予退还乙方已支付的费用。</p>
            <p>9. 因为甲方只能提供远程技术支持，无法完全掌握现场情况，并不直接操作设备硬件，所以在提供技术支持服务期间出现误操作引起的后果，甲方只承担退还乙方支付的本次技术服务费用的责任，不承担其它连带责任。</p>
            <p>第四条 保密条款</p>
            <p>1. 在本协议有效期内及协议终止后，甲方应保守乙方提供的咨询信息及相关资料，未经乙方许可不得向任何第三方披露，包括但不限于商业秘密、客户资料等。</p>
            <p>2. 乙方应保守甲方提供的服务过程中涉及的专业知识及商业机密，未经甲方许可不得向任何第三方披露或使用。</p>
            <p>第五条 协议生效与解除</p>
            <p>1. 本协议自乙方支持服务费用后生效，具有法律效力。</p>
            <p>2. 在以下情况下，本协议可被解除：</p>
            <p>a) 双方经协商一致解除；</p>
            <p>b) 一方违反本协议规定的责任。</p>
            <p>第六条 争议解决</p>
            <p>1. 本协议如出现争议，双方首先应友好协商解决。</p>
            <p>2. 如协商不成，任何一方可将争议提交至【陕西省西安市高新区仲裁办】进行解决。</p>
            <p> 第七条 其他条款</p>
            <p>1. 甲方在提供咨询服务之前，有权要求乙方提供必要的相关设备运行资料，以确保提供准确的咨询服务。</p>
            <p>2. 本协议未尽事宜，双方友好协商解决。</p>
            <p>3. 甲方拥有本协议最终解释权。</p>
        </div>
        <button style="margin-bottom: 15px;" class="btn btn_primary" @click="backToPay">返回</button>
    </div>
</template>

<script>
export default {
    name: 'UserAgreement',
    data() {
        return {
        }
    },
    methods: {
        backToPay() {
            this.$router.push('/pay')
        },
    },
    mounted() {
    },
    created() {
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "index";
</style>


// WEBPACK FOOTER //
// src/components/userAgreement.vue